const init = () => {
  document.querySelector('.header__search-overlay')?.addEventListener('click', () => {
    document.querySelector('.js-show-search').click();
    document.querySelector('body').classList.remove('overlay-predictive-search')

    if (window.matchMedia('(max-width: 1024px)').matches) {
      document.querySelector('body').classList.remove('show-mobile-searcher')
      document.querySelector('body').classList.remove('removeScroll')
      document.querySelector('body').classList.remove('history-show')

      setTimeout( () => {
        document.querySelector('.header.bg-theme-bg.text-theme-text.has-motion').classList.remove('search-is-visible')
      }, 200 )
      setTimeout( () => {
        document.querySelector('.header.bg-theme-bg.text-theme-text.has-motion').classList.remove('search-is-visible')
      }, 400 )
      setTimeout( () => {
        document.querySelector('.header.bg-theme-bg.text-theme-text.has-motion').classList.remove('search-is-visible')
      }, 1000 )
    }
  });

  document.querySelector('.custom-mobile-search-header-close')?.addEventListener('click', () => {
    document.querySelector('.header__search-overlay').click();
  });
  document.querySelector('.custom-mobile-search-header-cart')?.addEventListener('click', () => {
    document.querySelector('.header__search-overlay').click();
    document.querySelector('.header__icon.item-cart').click();
    
  });



  document.querySelector('.search-link-close')?.addEventListener('click', () => {
    document.querySelector('.js-show-search').click();
    document.querySelector('body').classList.remove('overlay-predictive-search')
  });
  document.querySelector('.search-link-cart')?.addEventListener('click', () => {
    document.querySelector('.js-show-search').click();
    document.querySelector('.header__icon.item-cart').click();
  });


  document.querySelector('.header__grid .js-show-search')?.addEventListener('click', () => {
    document.querySelector('body').classList.toggle('removeScroll');
  });


  document.querySelector('.view-more')?.addEventListener('click', () => {
    document.querySelector('.collection-seo-text')?.classList.add('show-more');
  });
  document.querySelector('.view-less')?.addEventListener('click', () => {
    document.querySelector('.collection-seo-text')?.classList.remove('show-more');
  });

  document.querySelector('.template-collection .mobile-collections-selector')?.addEventListener('click', () => {
    document.querySelector('.is-alternate-mode.is-tabs-mode .slider').classList.toggle('opened');
  });


  function getCartItemCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const totalItems = cart.items.reduce((sum, item) => sum + item.quantity, 0);
        const numberCounter = document.querySelector('.shopify-section store-header.header .header__grid .header__icons .item-cart span')
        
        if (numberCounter) {
          numberCounter.innerHTML = `Cesta | ${totalItems} |`
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
  
  setInterval(getCartItemCount, 1000);


  const productTabs = document.querySelectorAll('.template-product .product-collections-lists-links .slider__item')
  if (productTabs && productTabs[0]) {
    for (const productTab of productTabs) {
      productTab.addEventListener('click', () => {
        productTab.classList.toggle('active');
      });
    }
  }

  if (window.matchMedia('(max-width: 1024px)').matches) {
    const searchInput = document.querySelector('.header__grid .header__search predictive-search .search search-form .search__input')
    if (searchInput) {
      searchInput.addEventListener('click', () => {
        document.querySelector('body').classList.add('history-show')
        document.querySelector('body').classList.add('show-mobile-searcher')
      })
    }
  }


  const input = document.getElementById('header-search');

  input.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      window.location.href = `/search?q=${input.value}`
    }
  });
}

init();